import { TenantEntity } from '../TenantEntity'

export class AirlineProductVoyage extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AirlineProduct'
  }

  // Getter and Setter for airlineProductUuid
  get airlineProductUuid() {
    return this._data.airlineProductUuid
  }
  set airlineProductUuid(airlineProductUuid) {
    this._data.airlineProductUuid = airlineProductUuid
  }

  // Getter and Setter for voyage
  get voyage() {
    return this._data.voyage
  }
  set voyage(voyage) {
    this._data.voyage = voyage || 1
  }

  // Getter and Setter for flightNumber
  get flightNumber() {
    return this._data.flightNumber
  }
  set flightNumber(flightNumber) {
    this._data.flightNumber = flightNumber || ''
  }

  // Getter and Setter for dischargingPort1
  get dischargingPort1() {
    return this._data.dischargingPort1
  }
  set dischargingPort1(dischargingPort1) {
    this._data.dischargingPort1 = dischargingPort1 || ''
  }

  // Getter and Setter for dischargingPort2
  get dischargingPort2() {
    return this._data.dischargingPort2
  }
  set dischargingPort2(dischargingPort2) {
    this._data.dischargingPort2 = dischargingPort2 || ''
  }

  // Getter and Setter for destinationPortCode
  get destinationPortCode() {
    return this._data.destinationPortCode
  }
  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode || ''
  }

  // Getter and Setter for transshipmentPort
  get transshipmentPort() {
    return this._data.transshipmentPort
  }
  set transshipmentPort(transshipmentPort) {
    this._data.transshipmentPort = transshipmentPort || ''
  }

  // Getter and Setter for basicWeight
  get basicWeight() {
    return this._data.basicWeight
  }
  set basicWeight(basicWeight) {
    this._data.basicWeight = basicWeight || 0.0
  }

  // Getter and Setter for limitWeight
  get limitWeight() {
    return this._data.limitWeight
  }
  set limitWeight(limitWeight) {
    this._data.limitWeight = limitWeight || 0.0
  }

  // Getter and Setter for availableCabinSpace
  get availableCabinSpace() {
    return this._data.availableCabinSpace
  }
  set availableCabinSpace(availableCabinSpace) {
    this._data.availableCabinSpace = availableCabinSpace || 0.0
  }

  // Getter and Setter for limitLength
  get limitLength() {
    return this._data.limitLength
  }
  set limitLength(limitLength) {
    this._data.limitLength = limitLength || 0
  }

  // Getter and Setter for limitHeight
  get limitHeight() {
    return this._data.limitHeight
  }
  set limitHeight(limitHeight) {
    this._data.limitHeight = limitHeight || 0
  }

  // Getter and Setter for theoryVolume
  get theoryVolume() {
    return this._data.theoryVolume
  }
  set theoryVolume(theoryVolume) {
    this._data.theoryVolume = theoryVolume || 0.0
  }

  // Getter and Setter for sellableVolume
  get sellableVolume() {
    return this._data.sellableVolume
  }
  set sellableVolume(sellableVolume) {
    this._data.sellableVolume = sellableVolume || 0.0
  }
}
